<template>
  <div id="checkout" class="netPay">
    <div class="container" v-show="!showFrame">
      <!-- Content here -->
      <div class="card mb-5">
        <div class="card-content">
          <div class="logop">
            <img width="150" src="img/netpay.png">
          </div>
          <div class="row mb-5">
            <div class="col"></div>
          </div>
          <div class="row mb-5">
            <!-- Form --->

            <div class="col align-self-center">
              <div class="mb-5">
                <h3 class="mb-5">Ingrese los datos asociados a su tarjeta</h3>
              </div>
              <div class="row justify-content-md-center mb-3">
                <!--Billing data-->
                <div class="col-md-6 text-left">
                  <input
                    class="form-control form-control-sm"
                    type="text"
                    placeholder="Nombre"
                    ref="firstName"
                    style="text-transform:uppercase"
                    v-validate="'required'"
                    name="nombre"
                  >
                  <small class="error" v-if="errors.has('nombre')">{{errors.first('nombre')}}</small>
                </div>
                <div class="col-md-6 text-left">
                  <input
                    class="form-control form-control-sm"
                    type="text"
                    placeholder="Apellido"
                    ref="lastName"
                    style="text-transform:uppercase"
                    v-validate="'required'"
                    name="apellido"
                  >
                  <small class="error" v-if="errors.has('apellido')">{{errors.first('apellido')}}</small>
                </div>
              </div>
              <div class="row justify-content-md-center mb-3">
                <div class="col-md-6 text-left">
                  <input
                    class="form-control form-control-sm"
                    type="text"
                    placeholder="E-MAIL"
                    ref="email"
                    v-validate="'required|email'"
                    name="email"
                  >
                  <small class="error" v-if="errors.has('email')">{{errors.first('email')}}</small>
                </div>
                <div class="col-md-6 text-left">
                  <input
                    class="form-control form-control-sm"
                    type="text"
                    placeholder="TELÉFONO"
                    ref="phoneNumber"
                    v-validate="'required'"
                    name="telefono"
                  >
                  <small class="error" v-if="errors.has('telefono')">{{errors.first('telefono')}}</small>
                </div>
              </div>
              <div class="row justify-content-md-center mb-3">
                <div class="col-md-6 text-left">
                  <input
                    class="form-control form-control-sm"
                    type="text"
                    placeholder="Calle"
                    ref="street1"
                    style="text-transform:uppercase"
                    v-validate="'required'"
                    name="calle"
                  >
                  <small class="error" v-if="errors.has('calle')">{{errors.first('calle')}}</small>
                </div>
                <div class="col-md-6 text-left">
                  <input
                    class="form-control form-control-sm"
                    type="text"
                    placeholder="Colonia"
                    ref="street2"
                    style="text-transform:uppercase"
                    v-validate="'required'"
                    name="colonia"
                  >
                  <small class="error" v-if="errors.has('colonia')">{{errors.first('colonia')}}</small>
                </div>
              </div>

              <div class="row justify-content-md-center mb-3">
                <div class="col-md-6 text-left">
                  <input
                    class="form-control form-control-sm"
                    type="text"
                    placeholder="Ciudad"
                    ref="city"
                    style="text-transform:uppercase"
                    v-validate="'required'"
                    name="ciudad"
                  >
                  <small class="error" v-if="errors.has('ciudad')">{{errors.first('ciudad')}}</small>
                </div>
                <div class="col-md-6 text-left">
                  <input
                    class="form-control form-control-sm"
                    type="text"
                    placeholder="C.P."
                    ref="postalCode"
                    v-validate="'required'"
                    name="CP"
                  >
                  <small class="error" v-if="errors.has('CP')">{{errors.first('CP')}}</small>
                </div>
              </div>

              <div class="row justify-content-md-center mb-3">
                <div class="col-md-6 text-left">
                  <select class ref="state" v-validate="'required'" name="estado">
                    <option>ESTADO</option>
                    <option value="AGUASCALIENTES">AGUASCALIENTES</option>
                    <option value="BAJA CALIFORNIA NORTE">BAJA CALIFORNIA NORTE</option>
                    <option value="BAJA CALIFORNIA SUR">BAJA CALIFORNIA SUR</option>
                    <option value="CAMPECHE">CAMPECHE</option>
                    <option value="CHIAPAS">CHIAPAS</option>
                    <option value="CHIHUAHUA">CHIHUAHUA</option>
                    <option value="COAHUILA">COAHUILA</option>
                    <option value="COLIMA">COLIMA</option>
                    <option value="CDMX">CDMX</option>
                    <option value="DURANGO">DURANGO</option>
                    <option value="ESTADO DE MEXICO">ESTADO DE MEXICO</option>
                    <option value="GUANAJUATO">GUANAJUATO</option>
                    <option value="GUERRERO">GUERRERO</option>
                    <option value="HIDALGO">HIDALGO</option>
                    <option value="JALISCO">JALISCO</option>
                    <option value="MICHOACAN">MICHOACAN</option>
                    <option value="MORELOS">MORELOS</option>
                    <option value="NAYARIT">NAYARIT</option>
                    <option value="NUEVO LEON">NUEVO LEON</option>
                    <option value="OAXACA">OAXACA</option>
                    <option value="PUEBLA">PUEBLA</option>
                    <option value="QUERETARO">QUERETARO</option>
                    <option value="QUINTANA ROO">QUINTANA ROO</option>
                    <option value="SAN LUIS POTOSI">SAN LUIS POTOSI</option>
                    <option value="SINALOA">SINALOA</option>
                    <option value="SONORA">SONORA</option>
                    <option value="TABASCO">TABASCO</option>
                    <option value="TAMAULIPAS">TAMAULIPAS</option>
                    <option value="TLAXCALA">TLAXCALA</option>
                    <option value="VERACRUZ">VERACRUZ</option>
                    <option value="YUCATAN">YUCATAN</option>
                    <option value="ZACATECAS">ZACATECAS</option>
                  </select>
                  <small class="error" v-if="errors.has('estado')">{{errors.first('estado')}}</small>
                </div>
                <div class="col-md-6 text-left">
                  <input
                    class="form-control form-control-sm"
                    type="text"
                    placeholder
                    ref="country"
                    value="MEXICO"
                    readonly
                  >
                </div>
              </div>

              <!--  <div class="row justify-content-md-center">
            <div class="col-md-6">
              
              <input
                v-model="ip"
                class="form-control form-control-sm"
                type="text"
                placeholder="IP"
                ref="ipAddress"
                readonly
              >
            </div>
              </div>-->
              <div class="row justify-content-md-center mt-5">
                <div class="col-md-2">
                  <div class="form-check">
                    <input
                      class="form-check-input radio"
                      type="radio"
                      name="cards"
                      id="exampleRadios1"
                      value="001"
                      checked
                      v-model="tcard"
                    >
                    <br>

                    <img src="https://pay.gtek.mx/img/ic_visa.png">
                    <!--<label class="form-check-label" for="exampleRadios1">Visa</label>-->
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-check">
                    <input
                      class="form-check-input radio"
                      type="radio"
                      name="cards"
                      id="exampleRadios2"
                      value="002"
                      v-model="tcard"
                    >
                    <br>
                    <img src="https://pay.gtek.mx/img/ic_master_card.png">
                    <!--  <label class="form-check-label" for="exampleRadios2">MasterCard</label>-->
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-check">
                    <input
                      class="form-check-input radio"
                      type="radio"
                      name="cards"
                      id="exampleRadios3"
                      value="003"
                      v-model="tcard"
                    >
                    <br>
                    <img src="https://pay.gtek.mx/img/ic_amex.png">
                    <!-- <label class="form-check-label" for="exampleRadios3">American Express</label>-->
                  </div>
                </div>

                <!-- <small class="error" v-if="errors.has('cards')">{{errors.first('cards')}}</small>-->
              </div>
              <div class="row actions mt-5">
                <div class="col">
                  <button type="button" class="btn btn-primary btn-sm" @click="validate()">Siguiente</button>
                </div>
              </div>
            </div>
            <!----- From Cont ------>
          </div>
        </div>
      </div>
    </div>
    <iframe
      id="frame"
      v-show="showFrame"
      name="webAuth"
      style="width: 100%; height: 100vh;"
      frameborder="0"
      scrolling="no"
    ></iframe>
    <form
      name="tokenForm"
      v-bind:action="newAction"
      method="POST"
      target="_blank"
      ref="form"
      v-show="false"
    >
      <input type="text" name="jwt" v-model="token_id">
      <br>
      <input type="submit" value="Submit">
    </form>
  </div>
</template>

<script>
import { servicesAR } from "@/components/services/servicesAR";
import axios from "axios";
export default {
  name: "storeMethod",
  data: () => ({
    deviceSessionId: "",
    token_id: "",
    ip: "",
    checkoutTokenId: "",
    MerchantResponseURL: "",
    newAction: "",
    tcard: "",
    showFrame: false
  }),
  props: {},
  computed: {
    cart() {
      return this.$store.state.cart;
    },
    computedAction() {
      return (
        "http://certificaciones.netpay.com.mx:7092/a-webapp/e-commerce/web-authorizer?checkoutTokenId=" +
        this.checkoutTokenId +
        "&checkoutDetail=true&MerchantResponseURL=" +
        this.MerchantResponseURL
      );
    }
  },
  methods: {
    validate() {
      var that = this;
      this.$validator.validateAll().then(function() {
        if (!that.errors.any()) {
          that.sendInfo();
        } else {
          alert("Ingrese los datos solicitados");
        }
      });
    },
    async sendInfo() {
      var that = this;

      console.log(this.$refs.state.value);
      console.log(this.$store.state.cart);

      /*  var loginInfo = JSON.stringify({
        validate: "4RN3TP4Y"
      });*/

      /*  var loginInfo = JSON.stringify({
        type: "Token"
      });

      const token = await servicesAR.loginNetpay(loginInfo);
      console.log(token.data);
      this.token_id = token.data;*/

      /* var data = JSON.stringify({
        storeIdAcq: "453463",
        promotion: "000000",
        transType: "Auth",
        checkout: {
          cardType: this.tcard,
          merchantReferenceCode: "14500056",
          bill: {
            city: this.$refs.city.value,
            country: "MX",
            firstName: this.$refs.firstName.value,
            lastName: this.$refs.lastName.value,
            email: this.$refs.email.value,
            phoneNumber: this.$refs.phoneNumber.value,
            postalCode: this.$refs.postalCode.value,
            state: this.$refs.state.value,
            street1: this.$refs.street1.value,
            street2: this.$refs.street2.value,
            ipAddress: this.ip
          },
          ship: {
            city: this.$refs.city.value,
            country: "MX",
            firstName: this.$refs.firstName.value,
            lastName: this.$refs.lastName.value,
            phoneNumber: this.$refs.phoneNumber.value,
            postalCode: this.$refs.postalCode.value,
            state: this.$refs.state.value,
            street1: this.$refs.street1.value,
            street2: this.$refs.street2.value,
            shippingMethod: "flatrate_flatrate"
          },
          itemList: [
            {
              id: 1,
              productSKU: this.$store.state.cart.adKey,
              unitPrice: this.$store.state.cart.adCost,
              productName: this.$store.state.cart.adTitle,
              quantity: 1,
              productCode: this.$store.state.cart.adKey
            }
          ],
          purchaseTotals: {
            grandTotalAmount: this.$store.state.cart.adCost,
            currency: "MXN"
          },
          merchanDefinedDataList: [
            {
              id: 93,
              value: this.$refs.phoneNumber.value
            },
            {
              id: 2,
              value: "Web"
            },
            {
              id: 37,
              value: "No"
            },
            {
              id: 20,
              value: "Asesorias"
            },
            {
              id: 23,
              value:
                this.$refs.firstName.value + " " + this.$refs.lastName.value
            },
            {
              id: 36,
              value: "Regular"
            },
            {
              id: 42,
              value: "Asesorias Remotas"
            },
            {
              id: 43,
              value: "483211"
            },
            {
              id: 44,
              value: "Puebla"
            },
            {
              id: 45,
              value: "72160"
            },
            {
              id: 46,
              value: "483211"
            },
            {
              id: 94,
              value: this.$store.state.cart.u
            }
          ]
        }
      });*/

      // console.log(data);

      //const webAuth = await servicesAR.webAuth(token.data, data);
      var loginInfo = JSON.stringify({
        type: "Checkout",
        token: this.token_id,
        data: {
          storeIdAcq: "453463",
          promotion: "000000",
          transType: "Auth",
          checkout: {
            cardType: this.tcard,
            merchantReferenceCode: "14500056",
            bill: {
              city: this.$refs.city.value,
              country: "MX",
              firstName: this.$refs.firstName.value,
              lastName: this.$refs.lastName.value,
              email: this.$refs.email.value,
              phoneNumber: this.$refs.phoneNumber.value,
              postalCode: this.$refs.postalCode.value,
              state: this.$refs.state.value,
              street1: this.$refs.street1.value,
              street2: this.$refs.street2.value,
              ipAddress: this.ip
            },
            ship: {
              city: this.$refs.city.value,
              country: "MX",
              firstName: this.$refs.firstName.value,
              lastName: this.$refs.lastName.value,
              phoneNumber: this.$refs.phoneNumber.value,
              postalCode: this.$refs.postalCode.value,
              state: this.$refs.state.value,
              street1: this.$refs.street1.value,
              street2: this.$refs.street2.value,
              shippingMethod: "flatrate_flatrate"
            },
            itemList: [
              {
                id: 1,
                productSKU: this.$store.state.cart.adKey,
                unitPrice: this.$store.state.cart.adCost,
                productName: this.$store.state.cart.adTitle,
                quantity: 1,
                productCode: this.$store.state.cart.adKey
              }
            ],
            purchaseTotals: {
              grandTotalAmount: this.$store.state.cart.adCost,
              currency: "MXN"
            },
            merchanDefinedDataList: [
              {
                id: 93,
                value: this.$refs.phoneNumber.value
              },
              {
                id: 2,
                value: "Web"
              },
              {
                id: 37,
                value: "No"
              },
              {
                id: 20,
                value: "Asesorias"
              },
              {
                id: 23,
                value:
                  this.$refs.firstName.value + " " + this.$refs.lastName.value
              },
              {
                id: 36,
                value: "Regular"
              },
              {
                id: 42,
                value: "Asesorias Remotas"
              },
              {
                id: 43,
                value: "483211"
              },
              {
                id: 44,
                value: "Puebla"
              },
              {
                id: 45,
                value: "72160"
              },
              {
                id: 46,
                value: "483211"
              },
              {
                id: 94,
                value: this.$store.state.cart.u
              }
            ]
          }
        }
      });

      const webAuth = await servicesAR.loginNetpay(loginInfo);
      this.token_id = webAuth.data.token;
      console.log("TokenID");
      console.log(this.token_id);
      this.$store.commit("TOKEN_TEMP", webAuth.data.token);
      console.log("CHECKOUT");
      console.log(webAuth);
      this.checkoutTokenId = webAuth.data.data.response.checkoutTokenId;
      /* this.MerchantResponseURL = encodeURIComponent(
        btoa("http://api.ar.gtek.mx/dev/successPayments")
      );*/
      this.MerchantResponseURL = encodeURIComponent(
        btoa(that.$store.state.successURL)
      );

      console.log("DatosAction");

      console.log(this.checkoutTokenId);

      this.newAction =
        webAuth.data.data.response.webAuthorizerUrl +
        "?checkoutTokenId=" +
        //  this.newAction =
        // "http://certificaciones.netpay.com.mx:7092/a-webapp/e-commerce/web-authorizer?checkoutTokenId=" +
        // "https://cert.netpay.com.mx/a-webapp/e-commerce/web-authorizer?checkoutTokenId=" +
        this.checkoutTokenId +
        "&checkoutDetail=true&MerchantResponseURL=" +
        this.MerchantResponseURL;
      console.log(this.newAction);
      this.showFrame = true;
      this.$nextTick(() => {
        var f = document.forms["tokenForm"];
        f.target = "webAuth";
        console.log(f);
        f.submit();
        // that.$refs.form.submit();
      });
    },
    getIP() {
      var that = this;
      axios
        .get("https://api.ipify.org?format=json")
        .then(function(response) {
          // handle success
          console.log(response);
          that.ip = response.data.ip;
        })
        .catch(function(error) {
          // handle error
          console.log(error);
        });
    }
  },
  created() {
    var that = this;
    this.getIP();
    console.log("NetPayDone");

    window.onmessage = async function(e) {
      var obj = JSON.parse(e.data);

      if (obj.id == "okTransaction") {
        console.log("Pago");
        console.log(obj);

        var data = JSON.stringify({
          transactionToken: obj.transactionToken,

          tokenRequest: that.$store.state.tokenTemp
        });

        const transactionStats = await servicesAR.transactionStatus(data);
        console.log("RespuestaTransacción");
        console.log(transactionStats);

        if (transactionStats.data.response.responseCode == "00") {
          var dat = JSON.stringify({
            adKey: that.$store.state.cart.adKey,
            payment: transactionStats.data
          });
          console.log(dat);
          const paymentNetpay = await servicesAR.paymentNetPay(dat);
          console.log("Respuesta de pago");
          console.log(paymentNetpay);

          var msg = JSON.stringify({
            success: true,
            adTitle: that.$store.state.cart.adTitle,
            //transactionID: e.data.orderID,
            pType: "3",
            adKey: that.$store.state.cart.adKey
            // data: charge.data
          });
          console.log(msg);
          window.opener.postMessage(msg, "*");
          window.close();
        } else {
          console.log("Fail");
          console.log(transactionStats);
          var msg = JSON.stringify({
            success: false,
            adTitle: that.$store.state.cart.adTitle,
            //transactionID: e.data.orderID,
            pType: "3",
            adKey: that.$store.state.cart.adKey
            // data: charge.data
          });
          window.opener.postMessage(msg, "*");
          window.close();
        }
      }
    };
  }
};
</script>
<style>
.error {
  color: red;
}

select {
  padding: 13px 29px !important;
  width: 100%;
  border: none;
  font-size: 13px;
  color: #333333;
  outline: none;
  border-radius: 5px;
  background-color: #fff;
}

.radio {
  width: 20px;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 10px;
}

input {
  margin-top: 10px;
}
</style>


